import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-add-gateway-deposit',
  templateUrl: './add-gateway-deposit.component.html',
  styleUrls: ['./add-gateway-deposit.component.css'],
})
export class AddGatewayDepositDialog {
  element: any = {};
  wallets: any[] = [];
  myForm: any;
  isEditMode: boolean = false;
  isFinal: boolean = false; // DEPOSITED / FAILED: only Reference and Note can be changed
  isSubmitting: boolean = false;
  errorMessage: string = '';
  today: Date = new Date();

  constructor(
    public dialogRef: MatDialogRef<AddGatewayDepositDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    public userService: UserService
  ) {
    this.element = data.record || {};
    this.isEditMode = !!this.element._id;
    // New deposits only for active gateways; an edit keeps its own (possibly inactive) gateway
    this.wallets = (data.wallets || []).filter((w) => w.IsGatewayActive || w.WalletKey === this.element.WalletKey);

    this.myForm = this.fb.group({
      WalletKey: [this.element.WalletKey || '', [Validators.required]],
      Amount: [this.element.Amount || '', [Validators.required, Validators.min(0.01)]],
      Reference: [this.element.Reference || '', [Validators.required, Validators.maxLength(100)]],
      SenderName: [this.element.SenderName || '', [Validators.maxLength(100)]],
      DepositDate: [this.element.DepositDate ? new Date(this.element.DepositDate) : new Date(), [Validators.required]],
      Note: [this.element.Note || '', [Validators.maxLength(200)]],
      BankConfirmed: [false],
    });

    // Gateway + MID can't change on an existing deposit
    if (this.isEditMode) {
      this.myForm.get('WalletKey').disable();
    }
    // A final deposit keeps its amount, sender and date
    this.isFinal = this.isEditMode && !!this.element.BankStatus && this.element.BankStatus !== 'PENDING';
    if (this.isFinal) {
      ['Amount', 'SenderName', 'DepositDate'].forEach((field) => this.myForm.get(field).disable());
    }
  }

  onSubmit() {
    if (this.myForm.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    const values = this.myForm.getRawValue();
    const formData: any = {
      _csrf: this.data._csrf,
      Amount: Number(values.Amount),
      Reference: String(values.Reference || '').trim(),
      SenderName: String(values.SenderName || '').trim(),
      DepositDate: moment(values.DepositDate).format('YYYY-MM-DD'),
      Note: values.Note,
    };

    let request;
    if (this.isFinal) {
      request = this.userService.updateGatewayDeposit({
        _csrf: this.data._csrf, _id: this.element._id, Reference: formData.Reference, Note: formData.Note,
      });
    } else if (this.isEditMode) {
      request = this.userService.updateGatewayDeposit({ ...formData, _id: this.element._id });
    } else {
      const wallet = this.wallets.find((w) => w.WalletKey === values.WalletKey) || {};
      request = this.userService.createGatewayDeposit({
        ...formData,
        GatewayCode: wallet.GatewayCode,
        MId: wallet.MId,
        BankStatus: values.BankConfirmed ? 'DEPOSITED' : 'PENDING',
      });
    }

    request.subscribe(
      (response: any) => {
        this.dialogRef.close({
          success: true,
          deposited: !this.isEditMode && values.BankConfirmed,
          message: (response && response.message) || (this.isEditMode ? 'Deposit updated' : 'Deposit added'),
        });
      },
      (error) => {
        this.isSubmitting = false;
        this.errorMessage = (error && error.error && error.error.message) || 'Failed to save deposit';
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/gateway-deposits/add-gateway-deposit/add-gateway-deposit.component.ts